import {useUpgradeModal} from 'app/toasts/hooks';
import {UPGRADE_MODALS} from 'app/toasts/slice';

interface Props<R> {
  actionToProtect: () => R;
  modalType: UPGRADE_MODALS;
  children: (action: () => R | undefined) => JSX.Element;
}

export function PerUserRequired<R>({
  actionToProtect,
  modalType,
  children,
}: Props<R>) {
  const {showUpgradeModalIfNotPerUser} = useUpgradeModal();

  const protectedAction = () =>
    showUpgradeModalIfNotPerUser(modalType, actionToProtect);

  return children(protectedAction);
}
